import { isProd } from './config';

// TODO - Move these to environment variables
export const APP_CLIENT_ID = isProd ? '5c57jet0umt20eu4c0hdvhqlsu' : '7dq3a93dm7sqq9d5a0q6road34';

export const USER_POOL_ID = isProd ? 'us-east-1_p4dNuHw1F' : 'us-east-1_i6HflmPK5';

export const IDENTITY_POOL_ID = isProd
  ? 'us-east-1:89532747-b212-4bf5-bc02-e1f8f2fed2fc'
  : 'us-east-1:2ddac85a-0494-4a8d-9f5d-fff348c2b570';

export const COGNITO_DOMAIN = isProd
  ? 'login.expeditiondata.com'
  : 'local-login.expeditiondata.com';

export const AWS_REGION = 'us-east-1';
export const ORIGINAL_URL_KEY = 'AUTH_ORIGINAL_REQUEST_URL';
export const TEMP_RESET_TOKEN = 'TEMP_RESET_TOKEN';
export const ACCESS_TOKEN_HEADER = 'x-access-token';
export const ID_TOKEN_HEADER = 'x-id-token';
export const REFRESH_TOKEN_HEADER = 'x-refresh-token';

export const ADMIN_GROUP = 'admin';
export const COGNITO_GROUPS_KEY = 'cognito:groups';
